module.exports = __webpack_public_path__ + "static/img/bg_end.43b0755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_end.png
// module id = fKki
// module chunks = 0